"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var Types = require("types");
var recompose_1 = require("recompose");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var download_1 = require("utils/download");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var utils_1 = require("../utils");
var permissions_1 = require("@caddigital/sok-reducers/lib/utils/permissions");
var mapStateToProps = function (state) {
    return {
        user: state.auth.current.user,
        token: state.auth.current.token,
        filesData: state.files.data,
        sortByOptions: state.files.sortByOptions,
        currentFolder: state.files.currentFolder,
        currentBid: state.bid.current.bid,
        data: state.files.data,
        selectedLanguage: (0, translate_1.getLanguage)()
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleMoveFilesOverlay: function () {
        dispatch(FilesActions.FolderTreeActions.copyFilesToggleOverlay(Types.Reducer.MOVE));
        dispatch(FilesActions.FolderTreeActions.setCopyOrMoveRootExpanded(true));
    },
    toggleCopyFilesOverlay: function () {
        dispatch(FilesActions.FolderTreeActions.copyFilesToggleOverlay(Types.Reducer.COPY));
        dispatch(FilesActions.FolderTreeActions.setCopyOrMoveRootExpanded(true));
    },
    downloadFiles: function (files, token, allVersions) {
        return function () {
            return (0, download_1.downloadOrOpenFiles)(files, token, allVersions, dispatch);
        };
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.default = enhance(function (props) {
    var isSuperAdmin = props.user.fold(false, function (user) { return user.level === 'SuperAdminUserGroup'; });
    return (React.createElement("div", { className: "file-list-tools-buttons" },
        React.createElement(sok_ui_1.ToolButton, { text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/addToCart'), disabled: props.selectedItems.length === 0, color: "green", icon: React.createElement(Icon_1.Icon, { className: "fa-cart-plus" }), onClick: props.addItemsToCart }),
        React.createElement(sok_ui_1.ToolButton, { text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/download'), disabled: props.selectedItems.length === 0, color: "blue", onClick: props.downloadFiles(props.selectedItems, props.token, false), icon: React.createElement(Icon_1.Icon, { className: "fa-cloud-download" }) }),
        isSuperAdmin && (React.createElement(sok_ui_1.ToolButton, { text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/downloadAll'), disabled: props.selectedItems.length === 0, color: "blue", onClick: props.downloadFiles(props.selectedItems, props.token, true), icon: React.createElement(Icon_1.Icon, { className: "fa-cloud-download" }) })),
        !props.currentBid &&
            props.selectedItems.length === 1 &&
            props.selectedItems[0].type !== 'FOLDER' &&
            (function () {
                var rev = props.selectedItems[0];
                if (rev.type.toString() === 'FOLDER') {
                    return undefined;
                }
                return (React.createElement(sok_ui_1.ToolButton, { className: "toggle-revisions", color: "gray", text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/revisions'), link: (props.currentFolder &&
                        "/".concat(props.selectedLanguage, "/projects/").concat(rev.project, "/files/").concat(rev.parent, "/revisions/").concat(rev.fileUuid)) ||
                        '', icon: React.createElement(Icon_1.Icon, { className: "fa-history" }) }));
            })(),
        props.showButtons && (React.createElement(React.Fragment, null,
            React.createElement(sok_ui_1.ToolButton, { color: "gray", text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/move'), disabled: props.currentFolder !== null
                    ? (props.currentFolder.perm & permissions_1.ACL_DELETE) === 0
                    : true, onClick: function () { return props.toggleMoveFilesOverlay(); }, icon: React.createElement(Icon_1.Icon, { className: "fa-arrows" }) }),
            React.createElement(sok_ui_1.ToolButton, { color: "gray", text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/copy'), onClick: function () { return props.toggleCopyFilesOverlay(); }, icon: React.createElement(Icon_1.Icon, { className: "fa-copy" }) }),
            React.createElement(sok_ui_1.ToolButton, { color: "gray", text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/edit'), disabled: props.isManySelections ||
                    (props.currentFolder !== null
                        ? (props.currentFolder.perm & permissions_1.ACL_WRITE) === 0
                        : true), onClick: function () {
                    var file = props.data.files.find(function (x) { return x.id === props.selectedItems[0].id; });
                    if (file) {
                        props.openOverlay('EDIT', file);
                    }
                }, icon: React.createElement(Icon_1.Icon, { className: "fa-pencil" }) }),
            !props.currentBid &&
                props.currentProject &&
                props.currentFolder &&
                props.currentFolder.id === props.currentProject.rootFolder &&
                props.currentProject.perm &
                    (acl.CUSTOMER_ADMIN_GRANT & ~acl.FEATURE_MASK) &&
                props.currentProject.perm & acl.SUBPROJECT_PERM ? (React.createElement(sok_ui_1.ToolButton, { color: 'gray', text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/editSubproject'), disabled: props.isManySelections ||
                    (props.currentFolder !== null
                        ? (props.currentFolder.perm & permissions_1.ACL_WRITE) === 0 ||
                            ((props.selectedItems[0].feature || 0x00) &
                                acl.SUBPROJECT_PERM) ===
                                0
                        : true), onClick: function () {
                    var file = props.data.files.find(function (x) { return x.id === props.selectedItems[0].id; });
                    if (file) {
                        props.openOverlay('EDIT_SUBPROJECT', file);
                    }
                }, icon: React.createElement(Icon_1.Icon, { className: "fa-pencil" }) })) : undefined,
            !props.currentBid &&
                props.currentProject &&
                props.currentFolder &&
                props.currentFolder.id === props.currentProject.rootFolder &&
                props.currentProject.perm &
                    (acl.CUSTOMER_ADMIN_GRANT & ~acl.FEATURE_MASK) &&
                props.currentProject.perm & acl.SUBPROJECT_PERM ? (React.createElement(sok_ui_1.ToolButton, { color: 'orange', text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/archiveSubproject'), disabled: props.isManySelections ||
                    (0, utils_1.isArchiveDisabled)(props.currentFolder, props.selectedItems[0], props.archiveStatusMeta), onClick: function () {
                    props.setArchiveSubprojectIsOpen(true);
                }, icon: React.createElement(Icon_1.Icon, { className: "fa-archive" }) })) : undefined,
            React.createElement(sok_ui_1.ToolButton, { color: 'red', text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/delete'), disabled: props.currentFolder !== null
                    ? (props.currentFolder.perm & permissions_1.ACL_DELETE) === 0
                    : true, onClick: function () { return props.setRemoveIsOpen(true); }, icon: React.createElement(Icon_1.Icon, { className: "fa-trash" }) }),
            props.currentProject &&
                props.selectedItems.length > 0 &&
                props.selectedItems[0].type === 'FOLDER' &&
                props.currentProject.perm & acl.FILESTAB_PLUS_PERM ? (React.createElement(sok_ui_1.ToolButton, { color: 'red', text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/scheduled-delete'), disabled: props.isManySelections ||
                    (props.currentFolder !== null
                        ? (props.currentFolder.perm & permissions_1.ACL_DELETE) === 0
                        : true), onClick: function () { return props.setScheduledRemoveIsOpen(); }, icon: React.createElement(Icon_1.Icon, { className: "fa-calendar-times" }) })) : undefined))));
});
